<div class="container">
	<div class="new-commerce-container">
		<div *ngIf="!start">
			<div class="imagen">
				<img src="assets/images/pana.svg" alt="" />
			</div>

			<div class="texto">
				<div class="title">
					<span>Agregá tu comercio</span><br />
					<span>y formá parte de la comunidad Yacaré</span><br />
				</div>
				<br />
				<div><span>Ingresá los datos de tu comercio y simplificá la manera de cobrar y pagar</span><br /></div>
				<br />
				<div>
					<span>(Cuando creás la cuenta para tu comercio vas a poder ingresar a la personal desde la aplicación móvil)</span>
				</div>
			</div>
			<br />
		</div>
		<div class="warn-validation" *ngIf="!this.isValidate">
			<span
				>Su usuario no se encuentra validado, por favor para validarlo y poder operar con normalidad ingrese a la aplicación
				movil, complete la validación de identidad y prueba de vida.</span
			>
		</div>
		<div class="boton-container" *ngIf="!start">
			<button
				[ngClass]="{ 'boton-active': isValidate, 'boton-disabled': !isValidate }"
				mat-raised-button
				(click)="start = !start; isInvalidForm = false"
				[disabled]="!isValidate"
			>
				Empecemos
			</button>
		</div>

		<form [formGroup]="form" (ngSubmit)="onSubmitHandler(form.value)" autocomplete="off">
			<div *ngIf="start">
				<span *ngIf="isInvalidForm" style="color: red"
					>*Por favor, para finalizar completá los campos que aparecen en rojo</span
				>
			</div>
			<br /><br />
			<div *ngIf="start">
				<div class="formularios">
					<div style="width: 100%">
						<span>Datos a completar</span><br /><br />

						<mat-form-field appearance="outline" style="width: 100%" [ngClass]="{ 'cuit-invalido': invalidCuit() }">
							<mat-label>CUIT*</mat-label>
							<input
								matInput
								type="text"
								placeholder="CUIT"
								mask="00-00000000-0"
								autocomplete="off"
								formControlName="comercioCuit"
								maxlength="13"
								(input)="cuitInputEventHandler($event.target.value)"
								[readonly]="cuitReadonly"
							/>
						</mat-form-field>

						<search-place-component
							tabindex="3"
							formControlName="domicilioComercial"
							(selectedEvent)="selectedPlaceEventHandler($event)"
							(invalidAddresChild)="invalidAddresParent($event)"
						>
						</search-place-component>

						<div style="width: 100%; display: grid; grid-auto-flow: column; grid-template-columns: 49% 49%; grid-gap: 2%">
							<mat-form-field appearance="outline" style="width: 100%">
								<mat-label>Piso</mat-label>
								<input
									type="text"
									matInput
									maxlength="4"
									autocomplete="off"
									formControlName="departamentoPiso"
									[placeholder]="translate('pages.profile.labels.dept-floor')"
								/>
							</mat-form-field>
							<mat-form-field appearance="outline" style="width: 100%">
								<mat-label>Departamento</mat-label>
								<input
									type="text"
									matInput
									maxlength="4"
									autocomplete="off"
									formControlName="departamentoNumero"
									[placeholder]="translate('pages.profile.labels.dept-number')"
								/>
							</mat-form-field>
						</div>


						<mat-form-field appearance="outline" style="width: 100%;" >
							<mat-label>{{ 'pages.profile.labels.activity' | translate }}</mat-label>
							<mat-select formControlName="rubro" name="rubro">
								<mat-option *ngFor="let rubro of rubroOptionsCollection" [value]="rubro.value">
									{{ rubro.display }}
								</mat-option>
							</mat-select>
						</mat-form-field>

            <mat-form-field appearance="outline" style="width: 100%" [ngClass]="{ 'cuit-invalido': invalidComercioNombre() }">
							<mat-label>Nombre de fantasía*</mat-label>
							<input
								tabindex="4"
								#commerceName
								matInput
								formControlName="comercioNombre"
								(keyup)="trimValue($event.target.value, this.form.get('comercioNombre'))"
								maxlength="100"
								[placeholder]="translate('pages.profile.labels.fantasy_name')"
							/>
						</mat-form-field>


					</div>
					<div style="width: 100%">
						<span>Datos del comercio</span><br /><br />

						<mat-form-field appearance="outline" style="width: 100%">
							<mat-label>Razón social</mat-label>
							<input
								matInput
								formControlName="comercioRS"
								maxlength="255"
								[placeholder]="translate('pages.profile.labels.bussines_name')"
								readonly
							/>
						</mat-form-field>

						<mat-form-field appearance="outline" style="width: 100%">
							<mat-label>Domicilio fiscal</mat-label>
							<input
								matInput
								formControlName="domicilioFiscal"
								maxlength="255"
								[placeholder]="translate('pages.profile.labels.legal_address')"
								readonly
							/>
						</mat-form-field>

						<mat-form-field appearance="outline" style="width: 100%">
							<mat-label>Servicio</mat-label>
							<input
								matInput
								type="text"
								name="comercioRubro"
								formControlName="comercioRubro"
								maxlength="255"
								[placeholder]="translate('pages.profile.labels.service_category')"
								readonly
							/>
						</mat-form-field>

						<mat-form-field  appearance="outline" style="width: 100%;">
							<mat-label>Condición frente al IVA</mat-label>
							<input
								matInput
								formControlName="condicionIVA"
								[placeholder]="translate('pages.profile.labels.bussines_name')"
								readonly
							/>
						</mat-form-field>

						<mat-form-field style="width: 100%" *ngIf="hasApiToken" appearance="outline" class="code-token-form">
							<div class="container-code-token">
								<div>
									<mat-label style="color: rgba(0, 0, 0, 0.54); font-size: inherit">{{
										'pages.profile.labels.security_code' | translate
									}}</mat-label>
								</div>
								<div class="token-actions" style="top: -10px; display: flex" [ngSwitch]="visibility">
									<button *ngSwitchCase="true" mat-icon-button type="button" (click)="changeVisibility()">
										<mat-icon>remove_red_eye</mat-icon>
									</button>
									<button *ngSwitchCase="false" mat-icon-button type="button" (click)="changeVisibility()">
										<mat-icon>visibility_off</mat-icon>
									</button>
									<button [hidden]="visibility" mat-icon-button type="button" (click)="copyToken()">
										<mat-icon>file_copy</mat-icon>
									</button>
								</div>
							</div>
							<textarea
								formControlName="apiToken"
								#txtToken
								matInput
								[rows]="rowTxt"
								[(ngModel)]="valueToken"
								[hidden]="visibility"
								readonly
							></textarea>
						</mat-form-field>
					</div>
				</div>
				<div class="boton-container" *ngIf="start">
					<div style="width: 100%; display: flex">
						<section style="margin-right: 0.5rem">
							<mat-checkbox
								[checked]="this.currentUser?.organismo"
								[disabled]="this.currentUser?.organismo"
								(change)="changeStatusCheck()"
							>
							</mat-checkbox>
						</section>
						<div>
							<a
								class="terms"
								href="https://www.yacare.com/terminos-y-condiciones/"
								target="_blank"
								rel="noopener noreferrer"
								>{{ 'pages.profile.labels.aceptTerm' | translate }}</a
							>
						</div>
					</div>
					<div class="buttons-forms">
						<button mat-button class="button-cancel" (click)="start = !start; this.form.reset()">Cancelar</button>
						<button
							mat-raised-button
							button="submit"
							tabindex="0"
							color="primary"
							class="w-button button-actions font-clear button-save"
							[disabled]="getStatusButton()"
						>
							<div style="display: flex; justify-content: center" class="button-with-spinner">
								{{ 'commons.buttons.save' | translate }}
								<div *ngIf="saving">
									<mat-spinner [diameter]="20"></mat-spinner>
								</div>
							</div>
						</button>
					</div>
				</div>
			</div>
		</form>
	</div>
</div>
